<template>
  <div>
    <vs-row vs-type="flex" vs-w="12">
              <vs-col v-if="$isCenterBranch()" vs-type="flex" class="w-auto">
                <vx-tooltip text="Yeni Mood" position="top">
                  <vs-button
                    @click="addNewData"
                    class="panel-action text-success xlarge-button panel-action-box-shadow"
                    color="transparent"
                    icon-pack="feather"
                    icon="icon-plus"
                  >
                  </vs-button>
                </vx-tooltip>
              </vs-col>
            </vs-row>
  
  <data-view-sidebar
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :data="sidebarData"
    />
    <table>
      <thead>
        <tr>
          <th>Mood Resmi</th>
          <th>Açıklama</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(mood, index) in moods" :key="index">
          <td><img style="height: 100px; width: 100px   ;" :src="$baseUrl + '/' + mood.imageUrl" :alt="mood.description"></td>
          <td>{{ mood.description }}</td>
          <td> 
             <!-- <vs-button title="Moodu Sil" type="gradient" color="danger" icon-pack="feather" icon="icon-trash"></vs-button> -->
            <vs-button @click="editData(mood)" title="Moodu Düzenle" type="gradient" color="warning" icon-pack="feather" icon="icon-edit"></vs-button>
        </td>
        </tr>
      </tbody>
    </table>
  </div>
  </template>

<script>
import {GetMoodProfileImages} from "@/api/MoodProfileImage.js";
import DataViewSidebar from "./NewMoodProfileImage.vue";
export default {
  components: {
        DataViewSidebar
  },
    data() {
    return {

        moods:[],
        addNewDataSidebar: false,
        sidebarData: {},
        selected: "",
        newData:{
          imageUrl: ""
        },
    }
},
created() {
    this.getMoodProfileImages();
  },
  methods: {
    getMoodProfileImages : function () {
      GetMoodProfileImages()
      .then((res) => {
        if (res && res.status === 200){
          this.moods = res.data.data.results;
        } else{
          this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Mood resimleri yüklenemedi.",
            });
        }
      }).catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !" + error,
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
      val == false ? (this.selected = "") : null;
    },
    addNewData() {
      this.sidebarData = this.newData;
      this.toggleDataSidebar(true);
    },
    editData(data) {
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    }
  }
}
</script><style>
table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  padding: 10px;
  text-align: center;
  border: 1px solid #ddd;
}

img {
  max-width: 100%;
  height: auto;
}
</style>